// Combination of all components
import React from "react";
import Container from "./components/Container";
import Card from "./components/Card";
import data from "./data";

function App() {
  const travels = data.map((data) => {
    return (
      <Card
        id={data.id}
        imageUrl={data.imageUrl}
        country={data.country}
        mapLink={data.mapLink}
        dateVisited={data.dateVisited}
        place={data.place}
        description={data.description}
        hasVisited={data.hasVisited}
      />
    );
  });
  return (
    <div role="main" className="bg-white w-screen sm:w-full min-h-screen py-4">
      <Container />
      <div className=" w-screen sm:w-4/5 bg-indigo-900 mx-auto rounded-2xl shadow-2xl mt-8 py-3 px-5 max-w-4xl md:flex md:flex-col md:items-center md:justify-center">
        <h2 className="font-medium text-center mb-5 text-white tracking-wider">
          Places you need to see!
        </h2>
        {travels}
      </div>
    </div>
  );
}

export default App;
